import { render } from "./CImg.vue?vue&type=template&id=d36505c2"
import script from "./CImg.vue?vue&type=script&lang=js"
export * from "./CImg.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__